import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export const useMakeFilter = (isReady) => {
	const selectedMakes = useSelector((state) => state.make.selectedMakes);

	// Capture the selectedMakes value that was present on mount.
	// We compare against it to detect the first real change.
	const mountValueRef = useRef(selectedMakes);
	// Once we've seen a change from the mount value, always forward.
	const hasFiredRef = useRef(false);

	useEffect(() => {
		// Skip if LocationsData is not yet available
		if (!isReady || !window.DDC?.LocationsData) {
			return;
		}

		// Skip if the value hasn't changed since mount (no user interaction)
		if (!hasFiredRef.current && selectedMakes === mountValueRef.current) {
			return;
		}

		hasFiredRef.current = true;

		// Skip if LocationsData already has the same makes — avoids double-write
		// when useResetMakeFilter dispatches resetMakes() after resetMakeFilter()
		// has already cleared the filter synchronously.
		const current = window.DDC.LocationsData.getActiveMakes?.() ?? [];
		if (current.length === 0 && selectedMakes.length === 0) {
			return;
		}

		window.DDC.LocationsData.setFilters({
			makes: selectedMakes
		});
	}, [isReady, selectedMakes]);
};
